import React from "react";
import seed from "../../images/seed.png";
import wallet from "../../images/wallet.png";
import metaMake from "../../images/MetaMask-icon.png";
import dollar from "../../images/dollar.png";
import search from "../../images/sreach.png";

function CreateMetaMask() {
  return (
    <section className="relative w-full max-w-[1460px] bg-white flex flex-col justify-center items-center p-4 sm:p-8 lg:px-[120px] lg:py-[120px] gap-8 overflow-hidden mx-auto">
      {/* Background decorative ellipses */}
      {/* <div className="absolute w-[1237.3px] h-[1237.3px] left-[-296px] top-[-232px] bg-gradient-to-br from-[rgba(198,232,215,0.2)] via-[rgba(22,162,89,0.2)] to-[rgba(5,102,53,0.2)] rounded-full pointer-events-none" /> */}

      {/* Title & Description */}
      <div className="w-full max-w-[720px] lg:h-[109px] flex flex-col justify-center items-center gap-3 z-0">
        <h1 className="font-bold text-[28px] sm:text-[32px] lg:text-[36px] leading-[43px] text-[#3B3B3B] text-center">
          Create Metamask Wallet
        </h1>
        <p className="text-[16px] sm:text-[18px] w-full lg:w-[800px] max-w-full text-[#3B3B3B] text-center mb-20">
          MetaMask is a cryptocurrency wallet and gateway to blockchain
          applications. This guide will walk you through the process of
          creating and securing your MetaMask account.
        </p>
      </div>

      {/* Main steps container */}
      <div className="w-full max-w-[1200px] mt-[40px] flex flex-col items-start gap-5 z-0">
        {/* Two columns row (steps 1-4) */}
        <div className="flex flex-col xl:flex-row items-start gap-5 xl:gap-[33px] w-full">
          {/* Left column (Step 1 & 2) */}
          <div className="w-full xl:flex-1 flex flex-col gap-5">
            {/* Step 1 card */}
            <div className="relative w-full bg-[rgba(231,246,236,0.48)] rounded-2xl p-6 sm:p-10 xl:p-0 xl:min-h-[424px]">
              <div className="w-full max-w-[420px] flex flex-col gap-[23px] xl:absolute xl:left-10 xl:top-1/2 xl:-translate-y-1/2 xl:w-[420px] xl:h-[223px]">
                {/* Image placeholder */}
                <img src={search} alt="" className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] object-contain" />
                {/* Step 1 text */}
                <div className="w-full flex flex-col gap-[11px] xl:h-[152px]">
                  <h2 className="text-[#141414] text-[20px] sm:text-[22px] lg:text-[24px] font-medium leading-[29px]">
                    Step 1: Install MetaMask Extension
                  </h2>
                  <div className="flex flex-col gap-3">
                    <p className="text-[#898989] text-[16px] font-medium">
                      Visit the official MetaMask website (metamask.io)
                    </p>
                    <p className="text-[#898989] text-[16px] font-medium">
                      Click &quot;Download&quot; and choose your browser
                    </p>
                    <p className="text-[#898989] text-[16px] font-medium">
                      Click &quot;Add to Browser&quot; or &quot;Install&quot;
                    </p>
                    <p className="text-[#898989] text-[16px] font-medium">
                      Pin the extension to your browser toolbar for easy access
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2 card */}
            <div className="w-full bg-[rgba(20,149,84,0.05)] rounded-2xl p-6 sm:p-10 xl:p-[60px_40px] xl:min-h-[424px] flex flex-col gap-6">
              {/* Icon placeholder */}
              <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] lg:w-[100px] lg:h-[100px] rounded flex items-center justify-center text-xs flex-shrink-0">
                <img src={wallet} alt="" className="w-full h-full object-contain" />
              </div>
              <div className="w-full flex flex-col gap-4">
                <h2 className="text-[#141414] text-[20px] sm:text-[22px] lg:text-[24px] font-medium leading-[29px]">
                  Step 2: Create a New Wallet
                </h2>
                <div className="flex flex-col gap-3">
                  <p className="text-[#898989] text-[16px] font-medium">
                    Click the MetaMask icon in your browser
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Click &quot;Get Started&quot;
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Select &quot;Create a New Wallet&quot;
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Create a strong password
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right column (Step 3 & 4) */}
          <div className="w-full xl:flex-1 flex flex-col gap-5">
            {/* Step 3 card */}
            <div className="w-full bg-[#F7FBF4] rounded-2xl p-6 sm:p-10 xl:p-[25px_40px] xl:min-h-[148px] flex flex-col gap-[23px]">
              {/* Icon placeholder */}
              <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] lg:w-[100px] lg:h-[100px] rounded flex items-center justify-center text-xs flex-shrink-0">
                <img src={seed} alt="" className="w-full h-full object-contain" />
              </div>

              <div className="w-full flex flex-col">
                <h2 className="text-[#141414] text-[20px] sm:text-[22px] lg:text-[24px] font-medium">
                  Step 3: Secret Recovery Phrase
                </h2>
                <div className="flex flex-col">
                  <p className="text-[#898989] text-[16px] font-medium">
                    Click &quot;Next&quot; to reveal your 12-word Secret
                    Recovery Phrase
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Important security tips
                  </p>

                  <div className="text-[#898989] text-[14px] mb-3">
                    <div className="flex">
                      <div className="text-3xl font-extrabold mr-2">.</div>
                      <div className="text-[14px] mt-2">Write down the phrase on paper (never digitally)</div>
                      <br />
                    </div>
                    <div className="flex">
                      <div className="text-3xl font-extrabold mr-2">.</div>
                      <div className="text-[14px] mt-2">Write words in exact order</div>
                      <br />
                    </div>
                    <div className="flex">
                      <div className="text-3xl font-extrabold mr-2">.</div>
                      <div className="text-[14px] mt-2">Double-check spelling</div>
                      <br />
                    </div>
                    <div className="flex">
                      <div className="text-3xl font-extrabold mr-2">.</div>
                      <div className="text-[14px] mt-2">Store in a secure, private location</div>
                      <br />
                    </div>
                    <div className="flex">
                      <div className="text-3xl font-extrabold mr-2">.</div>
                      <div className="text-[14px] mt-2">Never share with anyone</div>
                      <br />
                    </div>
                    <div className="flex">
                      <div className="text-3xl font-extrabold mr-2">.</div>
                      <div className="text-[14px] mt-2">MetaMask support will never ask for this phrase</div>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 4 card */}
            <div className="w-full bg-[#F7FBF4] rounded-2xl p-6 sm:p-10 xl:p-[60px_40px] xl:min-h-[100px] flex flex-col gap-[23px]">
              {/* Icon placeholder */}
              <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] lg:w-[100px] lg:h-[100px] rounded flex items-center justify-center text-xs flex-shrink-0">
                <img src={dollar} alt="" className="w-full h-full object-contain" />
              </div>
              <div className="w-full flex flex-col gap-4">
                <h2 className="text-[#141414] text-[20px] sm:text-[22px] lg:text-[24px] font-medium leading-[29px]">
                  Step 4: Verify Recovery Phrase
                </h2>
                <div className="flex flex-col gap-3">
                  <p className="text-[#898989] text-[16px] font-medium">
                    Select each word in the correct order when prompted
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Click &quot;Confirm&quot; to complete verification
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    You&apos;ll see a &quot;Congratulations&quot; message upon
                    successful completion
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Sign Up and create password
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Step 5 full-width card */}
        <div className="w-full bg-[#F4FBF6] rounded-2xl mt-10 p-6 sm:p-10 xl:p-[60px_40px] xl:min-h-[309px] flex flex-col gap-[23px]">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-[23px] w-full xl:min-h-[189px]">
            {/* Fox icon placeholder */}
            <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] xl:w-[100px] xl:h-[96.39px] rounded flex items-center justify-center text-xs flex-shrink-0">
              <img src={metaMake} alt="" className="w-full h-full object-contain" />
            </div>
            {/* Step 5 text */}
            <div className="flex-1 flex flex-col gap-4 min-w-0">
              <h2 className="text-[#141414] text-[20px] sm:text-[22px] lg:text-[24px] font-medium leading-[29px]">
                Step 5: Account Security
              </h2>
              <div className="flex flex-col gap-3">
                <p className="text-[#898989] text-[16px] font-medium">
                  Go to Settings &gt; Security &amp; Privacy
                </p>
                <p className="text-[#898989] text-[16px] font-medium">
                  Enable auto-lock feature
                </p>
                <p className="text-[#898989] text-[16px] font-medium">
                  Set a reasonable timeout period
                </p>
                <p className="text-[#898989] text-[16px] font-medium">
                  Consider enabling enhanced privacy settings
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CreateMetaMask;